export default __webpack_public_path__ + "static/media/etf.27f9df57.svg";